import { Step, getOverdueInvoices, sumAmounts } from '../core/utils'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import Item from '../core/Item'
import React from 'react'

interface SummaryProps {
  response?: payments.Quote
  setStep: React.Dispatch<React.SetStateAction<Step>>
}

const Summary: React.FC<SummaryProps> = ({ response, setStep }) => {
  const overdueInvoices = getOverdueInvoices(response)
  const amount = sumAmounts(overdueInvoices.map(invoice => invoice.remainingAmount))

  const { goBack } = useHistory()
  const { t } = useTranslation('warehouse')

  return <>
    <div className='title'>
      <div>{t('payments')}</div>
      <div>{t('completeTheFormalities')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__list'>
        {overdueInvoices.length > 0 && <Item
          icon='payments'
          title={t('unpaidInvoices')}
          desc={`${overdueInvoices.length} ${t('invoicesForTheAmount')}: ${displayPrice(amount)}`}
        />}
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          text={amount > 0
            ? `${t('pay')} ${displayPrice(amount)}`
            : t('next')}
          action={() => {
            if (amount > 0) {
              setStep('payment')
            } else {
              goBack()
            }
          }}
        />

        <BackBtn />
      </div>
    </div>
  </>
}

export default Summary
